export default {"src":"/evde-internet/_next/static/media/close-borderless.b2ecf089.svg","height":24,"width":24};